/* eslint-disable array-callback-return, consistent-return, global-require */

import { canUseDOM } from 'exenv';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  get,
  set,
  find,
  toNumber,
  isEmpty,
  extend,
  isUndefined,
  throttle
} from 'lodash';
import Cookies from 'js-cookie';
import highlightShare from 'highlight-share/dist/highlight-share';
import * as twitterSharer from 'highlight-share/dist/sharers/twitter';
import * as facebookSharer from 'highlight-share/dist/sharers/facebook';
import Ad from '../../../components/ad/ad';
import Insert from '../../../components/post/content/insert';
import { imageSizesLookup } from '../../../../utils/cloudinary_asset_util';
import { isAdvertorial } from '../../../../views/components/advertorial/advertorial';
import PostsContainer from '../../../components/post/container';
import MoreStories from '../../../components/more-stories-component/more-stories-component';
import VideoModule from '../../../components/video_module/video_module';
import EditorHighlights from '../../../components/editor_highlights/editor_highlights';
import EventModel from '../../../../utils/tracking/models';
import withTracking from '../../../../utils/tracking/components/withTracking';
import { defaultEvent } from '../../../../utils/tracking/events/pageEvents';
import { UserContext } from '../../../components/context/userContext';
import PackageStickyNav from './packages/nav/package_sticky_nav';
import Dianomi from '../../../components/dianomi/dianomi_script';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import trackThirdPartyJS from '../../../../client/utils/third_party_trackers/trackThirdPartyJS';
import adsConfig from '../../../../config/ads';
import { buildPostAdModel } from '../../../../utils/ad_util';
import matchMediaDesktop from '../../../../utils/client_util';
import { findAdvertorialTagID } from '../../../../utils/advertorial_utils';
import { infiniteScrollUrlChange } from '../../../../redux/action_creators/post/postpage_action_creators';
import asyncPostFiniteActions from '../../../../redux/actions/post/async_post_finite_actions';
import asyncPostNativeAdActions from '../../../../redux/actions/post/async_post_native_ad_actions';
import adLoaded from '../../../../redux/action_creators/ads_action_creator';
import { isCategory } from '../../../../utils/category_util';
import generateVideoCustomParams from '../../../../utils/seo_utils/video/video_post_custom_params_util';

// Finite Scroll Components
import FiniteScroll from '../../../components/finite_scroll';

import { StickyBar } from '../../../components/StickyBar/StickyBar';

let scriptjs = false;
const nativeMap = {
  dianomiTiles: 'native_sponsoredtile',
  nativeSecond: 'nativeSecond',
  infiniteScroll: 'native_infinitescroll',
  midArticleInject: 'native_mid_article_inject',
  recommendations: 'native_recommendationlink'
};

if (canUseDOM) {
  scriptjs = require('scriptjs'); // eslint-disable-line global-require
}

class PostPage extends Component {
  constructor(props) {
    super(props);

    // console.log('✅ CONSTRUCTOR receieved initial post....', '\n', props.post);
    // console.log('✅ props postNativeAd', '\n', props.postNativeAd);

    const { live } = props.post;
    this.loaded = false;

    this.state = {
      finitePosts: [],
      displayingAdhesiveUnit: false,
      activeInserts: {},
      nativeInfiniteScrollData: {},
      secondScrollPost: {},
      parselyArticles: {}
    };

    // var init
    this.finiteScrollDepth = null;
    this.calledNativePixel = false;
    this.renderedNativeInfiniteScrollPost = false;
    this.canRenderInfiniteScroll = false;

    // For editorial packages...
    this.tags = get(props, 'post.tags', []).map(tag => tag.slug);
    const lookup = ['package-lander', 'package-article'];

    if (this.tags.map(tag => lookup.some(el => el === tag))) {
      const filteredPackageName = this.tags.filter(tag => {
        if (/^_package/.test(tag)) return tag;
      })[0];
      this.packageName = !isUndefined(filteredPackageName)
        ? filteredPackageName.replace('_package-', '')
        : null;
    }

    if (!this.packageName) {
      // Don't use scroll tracking if a package lander...
      this.setScrollEvents = throttle(() => {
        const { scrollY, innerHeight } = this.window;
        this.setFiniteScrollDepth(scrollY, innerHeight);
        this.setInviewPostUrl(scrollY, innerHeight);
      }, 1000);
    }

    if (this.packageName) {
      // Try to keep this list in alphabetical order for our sanity as it grows.
      switch (this.packageName) {
        case 'black-in-tech':
          this.packageComponent = require('./packages/black-in-tech').default;
          this.packageNav = false;
          break;

        case 'the-new-worker-moment':
          if (this.tags.includes('package-lander')) {
            this.packageComponent = require('./packages/fc-labor/package_lander.js').default;
            this.packageNav = true;
            break;
          } else if (this.tags.includes('package-article')) {
            this.packageComponent = require('./packages/fc-labor/package_article.js').default;
            this.packageNav = true;
            break;
          } else if (this.tags.includes('package-article-list')) {
            this.packageComponent = require('./packages/fc-labor/package_article_list.js').default;
            this.packageNav = true;
            break;
          } else {
            this.packageComponent = null;
            this.packageNav = false;
          }
          break;

        default:
          this.packageComponent = null;
          this.packageNav = false;
          break;
      }
    }

    this.generateAdData = this.generateAdData.bind(this);

    this.playerScriptIds = [
      'QV73eWiB',
      '4h5SWQPt',
      'Pafg29um',
      '27mBLzWL',
      'i70nsZ8K',
      'Lrp0YsKC',
      'wGNMZweZ',
      'kMmGs8qw',
      'WXJihrBk',
      'iqio3VCM',
      'OolwHeKf',
      'FsIzKJce',
      'r04h3Jdn',
      'RvGXj7in',
      'flarUGPa',
      'HzdTLaau',
      'gAy6i1bi',
      'RqEFED7X',
      'vp2iCnvh',
      'b2BPV4nc'
    ];

    this.live = get(live, 'enabled', false) && !!get(live, 'posts.length', 0);
    this.noscroll = false;
    this.firstIsSet = false;
    this.loadPostFinite = this.loadPostFinite.bind(this);
  }

  componentDidMount() {
    const { statusCode, post } = this.props;
    const postCategories = get(post, 'categories', false);

    this.window = window;
    this.windowWidth = this.window.innerWidth;
    this.body = document.body;
    this.activePost = get(post, 'id') || get(this.props, 'match.params.id');
    this.lazyThresholdFromBottom = 400;
    this.stickySidebar = matchMediaDesktop();
    this.trackedPosts = [];

    if (this.packageName) {
      document.body.classList.add(this.packageName);
    }

    if (get(this.props.config, 'featureFlags.textToShare')) {
      this.selectionShare = highlightShare({
        selector: '.post__body',
        sharers: [facebookSharer, twitterSharer],
        onOpen: element => {
          element.setAttribute('id', `user_highlight--${this.activePost}`);

          const event = new EventModel(
            'Highlight Share',
            'articleFormat',
            'hovered',
            'exposed',
            this.getPercentIntoPost(element)
          );
          this.props.trackEvent(event.getTrackingObject());
        }
      });
      this.selectionShare.init();
    }

    this.setActiveSocial();
    this.refreshSocialEmbeds();

    if (this.windowWidth < 768) {
      if (
        get(this.props, 'post.customFields.is_list', false) ||
        get(this.props, 'post.customFields.list_article.is_list_article', false)
      ) {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ displayingAdhesiveUnit: false });
      } else {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ displayingAdhesiveUnit: true });
      }
    } else {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ displayingAdhesiveUnit: false });
    }

    if (!this.live) {
      this.window.addEventListener('scroll', this.setScrollEvents);
    }

    if (
      statusCode !== 404 &&
      statusCode !== 403 &&
      statusCode !== 500 &&
      postCategories
    ) {
      this.loadPostFinite();
    }

    this.loaded = true;
  }

  componentWillReceiveProps(nextProps) {
    // console.log('🚨 post_page WILL RECEIEVE PROPS', '\n', nextProps);
    // probably not the best place to put this
    if (window.fc_ads && !window.fc_ads.getNative) {
      window.fc_ads.getNative = nativeType => {
        this.getNative(nativeType);
        this.props.dispatchAdLoadedEvent(nativeMap[nativeType], false);
      };
    }
    // if (isAdvertorial(get(nextProps, 'post.tags'))) {
    //   return;
    // }

    if (get(nextProps, 'postNativeAd.nativeSecond.posts', []).length > 0) {
      const nativeAd = get(window, `fc_ads.native.nativeSecond`); // eslint-disable-line
      const abGroupCookie = Cookies.get('abgroup');
      let defaultABGroup = 0; // eslint-disable-line
      if (abGroupCookie) {
        defaultABGroup = parseInt(abGroupCookie, 10);
      }

      if (
        typeof this.state.finitePosts.find(
          post =>
            post.id === get(nextProps, 'postNativeAd.nativeSecond.posts[0].id')
        ) === 'undefined'
      ) {
        this.setState({
          secondScrollPost: get(
            nextProps,
            'postNativeAd.nativeSecond.posts[0]'
          ),
          finitePosts: [
            ...this.state.finitePosts,
            get(nextProps, 'postNativeAd.nativeSecond.posts[0]')
          ]
        });
      }
    }
  }

  shouldComponentUpdate() {
    if (this.packageName) {
      return false;
    }
    return true;
  }

  componentDidUpdate(prevProps) {
    const live = get(this.props, 'post.live');
    this.live = get(live, 'enabled', false) && !!get(live, 'posts.length', 0);
    this.refreshSocialEmbeds();
    this.posts = this.getPostElements();
    const prevPropsCategories = get(prevProps, 'post.categories', false);
    const currPropsCategeroies = get(this.props, 'post.categories', false);

    if (
      prevPropsCategories !== currPropsCategeroies &&
      prevPropsCategories === false
    ) {
      this.loadPostFinite();
    }

    if (isEmpty(prevProps.post) && !isEmpty(this.props.post)) {
      this.firstIsSet = true;
      this.context.retriggerPianoPost(
        this.props.post,
        get(this.props.post, 'id', 'NI')
      );
    } else {
      const thisPost = get(this.props, 'post');
      if (!this.firstIsSet && !isEmpty(thisPost)) {
        this.firstIsSet = true;
        this.context.retriggerPianoPost(
          this.props.post,
          get(this.props.post, 'id', 'NI')
        );
      }
    }
  }

  componentWillUnmount() {
    if (!this.live) {
      this.window.removeEventListener('scroll', this.setScrollEvents);
    }
    if (get(this.props.config, 'featureFlags.textToShare')) {
      this.selectionShare.destroy();
    }
  }

  getPostElements() {
    return document.querySelectorAll('.post__body');
  }

  getPercentIntoPost(element) {
    const post = document.querySelector(`#post__wrapper-${this.activePost}`);
    const { top = 0, height = 0 } = post.getBoundingClientRect() || {};
    const postHeight = height - top;
    const highlightPosition = parseInt(element.style.top || 0, 10) - top;
    const percent = highlightPosition / postHeight * 100;
    return percent;
  }

  setActiveSocial(post) {
    const activeClass = 'social--active';
    const activeSocial = document.querySelector(`.${activeClass}`);

    if (activeSocial) {
      activeSocial.classList.remove(activeClass);
    }

    const activePost = post || document.querySelector('.post__wrapper');
    if (activePost && activePost.querySelector('.social')) {
      activePost.querySelector('.social').classList.add(activeClass);
    }
  }

  setFiniteScrollDepth(windowPosition, screenHeight) {
    const { postFinite, config, post } = this.props; // eslint-disable-line
    const RECIRC_OFFSET = 300;
    const bottomOfScreen = windowPosition + screenHeight;
    const recircPosition =
      document.querySelector('.recirc') &&
      document.querySelector('.recirc').offsetTop;
    const triggerPoint = recircPosition - RECIRC_OFFSET;

    if (triggerPoint < bottomOfScreen && get(postFinite, 'length')) {
      if (
        !this.renderedNativeInfiniteScrollPost &&
        get(this.props, 'nativeInfiniteScrollPost.length') &&
        !isAdvertorial(get(post, 'tags'))
      ) {
        this.setState(
          {
            finitePosts: [
              ...this.state.finitePosts,
              get(this.props, 'nativeInfiniteScrollPost[0]')
            ]
          },
          () => {
            this.renderedNativeInfiniteScrollPost = true;
          }
        );
      }
      this.setState({
        finitePosts: [...this.state.finitePosts, postFinite.shift()]
      });
    }
  }

  getNative(nativeType) {
    const nativeAd = get(window, `fc_ads.native.${nativeType}`);
    if (nativeAd) {
      return this.props.dispatchPostNativeAd(
        nativeAd,
        get(this.props, 'config')
      );
    }

    return false;
  }

  setActive(postID) {
    this.state.activeInserts[postID] = 1;
    this.forceUpdate();
  }

  setInviewPostUrl(windowPosition, screenHeight) {
    if (!this.posts || !get(this.posts, 'length')) {
      return false;
    }

    // const triggerPoint = windowPosition + screenHeight / 2;
    const triggerPoint = windowPosition + screenHeight;

    for (let i = 1; i <= get(this.posts, 'length'); i += 1) {
      const post = this.posts[i - 1];
      const sectionTopPosition = post.offsetTop;
      const sectionBottomPosition = sectionTopPosition + post.clientHeight;
      const postId = parseFloat(post.dataset.id);

      if (
        this.activePost !== postId &&
        sectionTopPosition <= triggerPoint &&
        sectionBottomPosition > triggerPoint
      ) {
        let postData =
          i === 1 ? this.props.post : this.state.finitePosts[i - 2];

        if (!isEmpty(this.state.secondScrollPost) && this.activePost === 0) {
          postData = this.state.secondScrollPost;
        }

        this.activePost = postData.id;

        // React router redux does not support replace state without page refresh.
        this.props.dispatchInfiniteScrollUrlChange();
        let replacedURL;
        if (postData.isNewUrl) {
          replacedURL = `/${postData.newUrl
            .split('/')
            .slice(-2)
            .join('/')}`;
        } else {
          const { search } = window.location || '';
          replacedURL = `/${postData.id}/${postData.slug}${search}`;
        }

        if (get(postData, 'isVideoPermalink')) {
          replacedURL = `/video/${postData.slug}/${get(
            postData,
            'posterVideo.feedId'
          )}`;
        }

        window.history.replaceState({}, '', replacedURL);

        // Only track this again on first post onwards
        // if (i > 1 && this.trackedPosts.indexOf(this.activePost) === -1) {
        this.trackedPosts.push(this.activePost);
        this.refreshThirdPartyTrackers(postData, i);
        // }

        this.setActiveSocial(post);
      }
    }
    return false;
  }

  loadPostFinite() {
    const postId = get(this.props, 'match.params.id');
    const config = get(this.props, 'config', {});
    const post = get(this.props, 'post', {});
    const postCategories = get(post, 'categories', []);
    const isMCPList = get(post, 'customFields.show_mcp_list', false);
    const isBWIList =
      get(post, 'customFields.select_the_list', false) === 'bwi2020';
    const isMICList =
      get(post, 'customFields.select_the_list', false) === 'mic2021';
    const isIBDList = find(get(post, 'tags'), {
      name: 'innovation by design 2020'
    });

    const advertorialTag = findAdvertorialTagID(get(post, 'tags'));
    const isRecommender = isCategory(postCategories, 'recommender');

    let override = null;

    if (isRecommender) {
      override = 'recommender';
    } else if (isMCPList) {
      override = 'mcp';
    } else if (isBWIList) {
      override = 'bwi';
    } else if (isIBDList) {
      override = 'ibd';
    } else if (find(get(post, 'tags'), { slug: 'innovation-festival-360' })) {
      override = 'innovation-festival-360';
    } else if (isMICList) {
      override = 'mic';
    } else {
      override = null;
    }

    this.props.dispatchPostFinite(
      postId,
      advertorialTag,
      config,
      this.props.mic2020Companies,
      this.props.mic2020Regions,
      this.props.mic2020Sectors,
      override
    );
  }

  refreshSocialEmbeds() {
    if (canUseDOM) {
      if (!window.instgrm) {
        scriptjs('//platform.instagram.com/en_US/embeds.js', () => {
          window.instgrm.Embeds.process();
        });
      } else {
        window.instgrm.Embeds.process();
      }

      scriptjs('//platform.twitter.com/widgets.js', () => {
        window.twttr.widgets.load();
      });
      // window.twttr.widgets.load();
      scriptjs('//view.ceros.com/scroll-proxy.min.js');
      scriptjs(
        '//creative-services.ceros.com/customer-success/varying-embed-tag-generator/embedded-variant-switcher-v3.min.js'
      );
    }
  }

  refreshThirdPartyTrackers(postData, pageNumber) {
    const { config } = this.props;
    const currentActivePostState = {
      context: {
        site: get(config, 'site'),
        type: 'post',
        postData
      },
      config
    };
    document.title = get(postData, 'title');
    trackThirdPartyJS(currentActivePostState, pageNumber);
    this.context.retriggerPianoPost(postData, get(postData, 'id', 'NI'));
  }

  generateAdData(postData) {
    const { config } = this.props;
    const site = get(config, 'site') || 'fastcompany';
    const adData = buildPostAdModel(adsConfig, site, postData, 'postPage');

    if (canUseDOM) {
      // Update the data layer
      if (find(get(postData, 'tags'), { slug: 'innovation-festival-360' })) {
        extend(window.digitalData.page.pageInfo, {
          adPath: `/4160/mv.fc/entertainment/innovationfestival360`
        });
      } else {
        extend(window.digitalData.page.pageInfo, {
          adPath: `/4160/mv.fc/${adData.model.adzone}`
        });
      }
    }

    return extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') || {} },
      { definitions: get(adData, 'config.definitions') || {} },
      { model: adData.model || {} }
    );
  }

  renderDianomiOrMoreStories(combinedAdModel) {
    const { config, postAfterbodyRecircModuleType } = this.props;
    const initialPageLoad = get(config, 'initialPageLoad');
    const moduleType = get(postAfterbodyRecircModuleType, 'type');
    // const moduleType = 'dianomi';

    // If user is international, display dianomi regardless of options
    if (!initialPageLoad && canUseDOM) {
      if (Cookies.get('fc_rev_content')) {
        return (
          <Dianomi
            initialPageLoad={initialPageLoad}
            site={get(config, 'site')}
            postNativeAd={this.props.postNativeAd}
            config={config}
          />
        );
      }
    }

    // If type is more stories in manage, display that
    if (moduleType === 'More Stories') {
      return this.renderMoreStories(combinedAdModel);
    }

    // Default to dianomi
    return (
      <Dianomi
        initialPageLoad={initialPageLoad}
        site={get(config, 'site')}
        postNativeAd={this.props.postNativeAd}
        config={config}
      />
    );
  }

  renderVideo() {
    const { postVideo, config, post } = this.props;
    const feedID = get(post, 'posterVideo.feedId');
    const customparams = generateVideoCustomParams(post);

    // Do not display video module when on a video post
    if (feedID) {
      return '';
    }

    if (!isEmpty(postVideo)) {
      const currentSite = get(this.props, 'config.site');
      get(config, 'site');
      return (
        <VideoModule
          config={config}
          data={postVideo}
          playerid="MyQ2uJQ0"
          pos="newmultiplayer"
          stories={this.props.postVideo.playlist}
          currentSite={currentSite}
          isPost={true}
          readTime={get(post, 'readTime')}
          customparams={customparams}
        />
      );
    }

    return null;
  }

  renderMoreStories(combinedAdModel) {
    let postMoreStories = get(this.props, 'postMoreStories.posts');

    const { postAfterbodyRecircModuleType, config } = this.props;
    const postAfterbodyRecircModuleTiles = get(
      postAfterbodyRecircModuleType,
      'tiles'
    );
    const postAfterbodyRecircModuleTilesAdzoneMetadata = get(
      postAfterbodyRecircModuleType,
      'tileAdzone',
      ''
    );

    const postAfterbodyRecircModuleTilesAdzoneMetadataSplit = postAfterbodyRecircModuleTilesAdzoneMetadata.split(
      ','
    );
    let slugData;

    if (postAfterbodyRecircModuleTiles) {
      const currentDate = new Date();
      const isEvenDay = toNumber(currentDate.getDate()) % 2 === 0;

      postMoreStories = postAfterbodyRecircModuleTiles.map((story, idx) =>
        Object.assign(story, {
          id: `12345-${idx}`,
          currentSite: get(config, 'site'),
          events: false,
          assetSizes: imageSizesLookup.bigFirstMobile,
          noLazy: true,
          isSponsoredTile: isEvenDay,
          external: true
        })
      );

      slugData = {
        name: get(postAfterbodyRecircModuleTilesAdzoneMetadataSplit, '[1]'),
        tagLine: get(postAfterbodyRecircModuleTilesAdzoneMetadataSplit, '[2]')
      };
    }

    if (
      postMoreStories &&
      get(postMoreStories, 'length') &&
      get(this.props, 'postFinite.length') &&
      canUseDOM
    ) {
      return (
        <Fragment>
          {postAfterbodyRecircModuleTilesAdzoneMetadata ? (
            <Fragment>
              <Ad
                {...combinedAdModel}
                pos="btf"
                noBorder={true}
                slug={false}
                adzoneOverride={get(
                  postAfterbodyRecircModuleTilesAdzoneMetadataSplit,
                  '[0]'
                )}
                name="nativecollectionmodule_01"
              />
              <MoreStories
                metadata={postMoreStories}
                isPost={true}
                slugData={slugData}
                config={this.props.config}
                hasSponsoredContentLabel={true}
                noBottomBorder={true}
              />
            </Fragment>
          ) : (
            <MoreStories
              metadata={postMoreStories}
              isPost={true}
              config={this.props.config}
            />
          )}
        </Fragment>
      );
    }

    return null;
  }

  renderPostFinite(
    postFinite,
    related,
    sticky,
    config,
    playerIds,
    event,
    combinedAdModel
  ) {
    if (!get(postFinite, 'length')) {
      return null;
    }

    return postFinite.map((postData, index) => {
      if (!postData) return null;

      if (postData.isVideoPermalink || get(postData, 'posterVideo.feedId')) {
        if (!playerIds[index + 1]) {
          set(postData, 'playerScriptId', 'G2hQKLvX');
        } else {
          set(postData, 'playerScriptId', playerIds[index + 1]);
        }
      }

      const expandVal = postData.cardType
        ? this.state.nativeInfiniteScrollData.expanded
        : undefined;

      return (
        <Fragment>
          <Ad
            {...combinedAdModel}
            name="native_infinitescroll"
            noBorder={true}
            slug={false}
            pos="atf"
            pageNum={index}
          />

          <Insert
            key={`insert_${index}`}
            expand={expandVal}
            config={config}
            tags={get(postData, 'tags')}
            postData={postData}
            insert={true}
            pageNum={index + 1}
            related={related}
            combinedAdModel={this.generateAdData(postData)}
            videoAdData={get(this.props.postpage, 'ads.model', {})}
            updateCorrelator={true}
            live={false}
            isDesktop={sticky}
            mic2020Companies={this.props.mic2020Companies}
            mic2020Regions={this.props.mic2020Regions}
            mic2020Sectors={this.props.mic2020Sectors}
            postPromoterArticleText={this.props.postPromoterArticleText}
            event={event}
          />
        </Fragment>
      );
    });
  }

  render() {
    // console.log('🚨 THIS SHOULD BE SOMEWHERE!!!!!!', '\n', );
    const {
      config,
      statusCode,
      post,
      related,
      postpage,
      postPromoterArticleText
    } = this.props;
    const abGroupCookie = Cookies.get('abgroup');
    let defaultABGroup = 0;
    if (abGroupCookie) {
      defaultABGroup = parseInt(abGroupCookie, 10);
    }

    /**
     * This post should be rendered as a "special package" view
     */
    if (this.packageComponent) {
      const PackageComponent = this.packageComponent;
      return (
        <Fragment>
          <PackageComponent
            post={post}
            combinedAdModel={this.generateAdData(post)}
            packageName={this.packageName}
          />
          {this.packageNav && <PackageStickyNav {...this.props} />}
        </Fragment>
      );
    }

    let shouldRenderVideoModule = true;
    // let shouldRenderDianomi = true;  commenting out bc of card ch48322

    // Groups 1-2: Hide all
    // Groups 3-20: No video/carousel
    //                       No newsletter signup
    //                       Only two Parsley "you might also like" links
    //                       Keep Dianomi
    if (
      (defaultABGroup >= 1 && defaultABGroup <= 2) ||
      isAdvertorial(get(post, 'tags'))
    ) {
      shouldRenderVideoModule = false;
      // shouldRenderDianomi = false; commenting out bc of card ch48322
    }
    if (defaultABGroup >= 3 && defaultABGroup <= 20) {
      shouldRenderVideoModule = false;
    }

    /**
     * Page data still loading, display loading component
     */
    if (postpage.isLoading && statusCode === 200) {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    /**
     * Error loading the page or page data, display error component
     */
    if (postpage.error || isEmpty(post)) {
      return (
        <section className="post-page">
          <article className="post__main--error-pg">
            <NotFound
              statusCode={statusCode}
              message={
                statusCode === 403 || statusCode === 401
                  ? 'Post is not available.'
                  : undefined
              }
            />
          </article>
        </section>
      );
    }

    const sticky = this.stickySidebar;
    // const fullPageCeros = get(
    //   post,
    //   'customFields.full_page_ceros_embed',  commenting out bc of card ch48322
    //   false
    // );

    const combinedAdModel = this.generateAdData(post);
    if (post.isVideoPermalink || get(post, 'posterVideo.feedId')) {
      set(post, 'playerScriptId', this.playerScriptIds[0]);
    }

    const customTagPlayerId = get(post, 'tags', []).filter(item =>
      get(item, 'slug', '').includes('jwplayer_')
    );

    if (customTagPlayerId.length > 0) {
      set(
        post,
        'playerScriptId',
        customTagPlayerId[0].slug.replace('jwplayer_', '')
      );
    }

    const events = ['innovation-festival-360'];
    let event = null;

    post.tags.forEach(tag => {
      if (events.includes(tag.slug)) {
        event = tag.slug;
      }
    });

    const containerProps = {
      config: this.props.config,
      posts: [post],
      combinedAdModel,
      pageNum: 0,
      related,
      isDesktop: sticky,
      isFirstPost: true,
      videoAdData: get(postpage, 'ads.model', {}),
      live: this.live,
      mic2020Companies: this.props.mic2020Companies,
      mic2020Regions: this.props.mic2020Regions,
      mic2020Sectors: this.props.mic2020Sectors,
      postPromoterArticleText,
      tags: post.tags,
      event: event || null,
      canRenderInfiniteScroll: this.canRenderInfiniteScroll,
      recircArticles: this.state.parselyArticles.recirc
    };

    return (
      <React.Fragment>
        <section className="post-page">
          {/* Editor Highlights marks, floating left unit */}
          {this.activePost && (
            <EditorHighlights activePostId={this.activePost} />
          )}

          {/* Bottom Adhesive ad unit [mobile only!] */}
          {this.state.displayingAdhesiveUnit &&
            !this.packageName && (
              <div className="adhesive adhesive-banner">
                <Ad
                  {...combinedAdModel}
                  noBorder={true}
                  slug={false}
                  collapseEmptyDiv={true}
                  name="mobile_adhesive"
                  // canRefresh={true}
                />
              </div>
            )}

          <section
            className={`post-page ${event ? `event-video ${event}` : ''} `}
          >
            <PostsContainer {...containerProps} />
          </section>

          {this.live || this.noscroll ? (
            <div className="post__article-top-ad-wrapper">
              <Ad
                {...combinedAdModel}
                name="flexiblebillboard"
                region="articlebottom"
                pageNum={1}
                pos="atf"
              />
              <Ad
                {...combinedAdModel}
                name="mobileleaderboard"
                region="articlebottom"
                pageNum={1}
                pos="atf"
              />
            </div>
          ) : (
            <div>{shouldRenderVideoModule ? this.renderVideo() : ''}</div>
          )}
        </section>

        {this.packageName && (
          <StickyBar
            slug={this.packageName}
            lists={null}
            location="article"
            post={post}
          />
        )}

        {/* FINITE EXPERIENCE */}
        {this.loaded && (
          <FiniteScroll
            post={post}
            secondScrollPost={this.state.secondScrollPost}
            articles={this.state.parselyArticles.articles}
            config={config}
            abGroup={defaultABGroup}
            adModels={{
              combined: combinedAdModel,
              secondScrollPost: this.generateAdData(
                this.state.secondScrollPost
              ),
              secondScrollVideo: get(this.props.postpage, 'ads.model', {})
            }}
            options={{
              sticky,
              event: event || '',
              related,
              videoAdData: get(this.props, 'postpage.ads.model', {}),
              mic2020Companies: get(this.props, 'mic2020Companies', []),
              mic2020Regions: get(this.props, 'mic2020Regions', []),
              mic2020Sectors: get(this.props, 'mic2020Sectors', []),
              postPromoterArticleText: get(
                this.props,
                'postPromoterArticleText',
                ''
              ),
              postNativeAd: get(this.props, 'postNativeAd', {})
            }}
          />
        )}
      </React.Fragment>
    );
  }
}

PostPage.contextType = UserContext;

function mapStateToProps(state = {}) {
  return {
    adsLoaded: get(state, 'ads.data'),
    statusCode: get(state, 'status.code'),
    config: state.config,
    postpage: state.postpage,
    post: get(state, 'post.data.post', {}),
    related: get(state, 'post.data.related', []),
    postVideo: get(state, 'postVideo.data', {
      feedid: '',
      playlist: [],
      title: ''
    }),
    postAfterbodyRecircModuleType: get(
      state,
      'postAfterbodyRecircModuleType.data'
    ),
    postPromoterArticleText: get(state, 'postPromoterArticleText.data.text'),
    postMoreStories: get(state, 'postMoreStories.data'),
    postFinite: get(state, 'postFinite.data.posts', []),
    postNativeAd: get(state, 'postNativeAd.data', {}),
    nativeInfiniteScrollPost: get(
      state,
      'postNativeAd.data.infiniteScroll.posts',
      []
    ),
    mic2020Companies: get(state, 'mic2020Companies.companies', []),
    mic2020Regions: get(state, 'mic2020Regions.regions', []),
    mic2020Sectors: get(state, 'mic2020Sectors.sectors', [])
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchInfiniteScrollUrlChange() {
      dispatch(infiniteScrollUrlChange());
    },

    dispatchPostFinite(
      id,
      advertorialTag,
      config,
      companies,
      regions,
      sectors,
      override
    ) {
      return asyncPostFiniteActions(
        dispatch,
        id,
        advertorialTag,
        config,
        companies,
        regions,
        sectors,
        override
      );
    },

    dispatchPostNativeAd(nativeAdsData, config) {
      return asyncPostNativeAdActions(dispatch, config, nativeAdsData);
    },

    dispatchAdLoadedEvent(adName, status) {
      dispatch(adLoaded(adName, status));
    }
  };
}

PostPage.defaultProps = {
  postAfterbodyRecircModuleType: {
    type: 'More Stories'
  },
  postPromoterArticleText: '',
  mic2020Companies: [],
  mic2020Regions: [],
  mic2020Sectors: []
};

PostPage.propTypes = {
  statusCode: PropTypes.number.isRequired,
  config: PropTypes.shape({}).isRequired,
  dispatchInfiniteScrollUrlChange: PropTypes.func.isRequired,
  dispatchPostNativeAd: PropTypes.func.isRequired,
  dispatchPostFinite: PropTypes.func.isRequired,
  dispatchAdLoadedEvent: PropTypes.func.isRequired,
  post: PropTypes.shape({
    id: PropTypes.number,
    customFields: PropTypes.shape({
      is_list: PropTypes.bool
    }),
    tags: PropTypes.arrayOf(PropTypes.shape([]))
  }).isRequired,
  related: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  postpage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    postScrollDepth: PropTypes.number
  }).isRequired,
  postVideo: PropTypes.shape({
    feedid: PropTypes.string,
    playlist: PropTypes.arrayOf(PropTypes.shape({})),
    title: PropTypes.string
  }).isRequired,
  postFinite: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  postNativeAd: PropTypes.shape({}).isRequired,
  postAfterbodyRecircModuleType: PropTypes.shape({
    type: PropTypes.string
  }),
  postPromoterArticleText: PropTypes.string,
  trackEvent: PropTypes.func.isRequired,
  mic2020Companies: PropTypes.arrayOf(PropTypes.shape()),
  mic2020Regions: PropTypes.arrayOf(PropTypes.shape()),
  mic2020Sectors: PropTypes.arrayOf(PropTypes.shape())
};

const mapTrackingToProps = trackEvent => ({
  trackEvent: pageObject => trackEvent(defaultEvent(pageObject))
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withTracking(mapTrackingToProps)(PostPage)
);
